module.exports = __webpack_public_path__ + "img/col.c2c59477.svg";